import { render, staticRenderFns } from "./RegisterBackups.vue?vue&type=template&id=5d30d072"
import script from "./RegisterBackups.vue?vue&type=script&lang=js"
export * from "./RegisterBackups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports